import { useState } from "react";
import {
  FacebookShareButton,
  TwitterShareButton,
  WhatsappShareButton,
  TelegramShareButton,
  LinkedinShareButton,
  EmailShareButton,
} from "react-share";
import {
  FacebookIcon,
  TwitterIcon,
  WhatsappIcon,
  TelegramIcon,
  LinkedinIcon,
  EmailIcon,
} from "react-share";

interface Props {
  shareUrl: string;
  title?: string;
}

function SocialMediaPopUp({ shareUrl, title = "" }: Props) {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    await navigator.clipboard.writeText(shareUrl);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const networks = [
    {
      name: "Facebook",
      Button: FacebookShareButton,
      Icon: FacebookIcon,
      props: { url: shareUrl, hashtag: "#AYOZAT" },
    },
    {
      name: "X",
      Button: TwitterShareButton,
      Icon: TwitterIcon,
      props: { url: shareUrl, title },
    },
    {
      name: "WhatsApp",
      Button: WhatsappShareButton,
      Icon: WhatsappIcon,
      props: { url: shareUrl, title },
    },
    {
      name: "Telegram",
      Button: TelegramShareButton,
      Icon: TelegramIcon,
      props: { url: shareUrl, title },
    },
    {
      name: "LinkedIn",
      Button: LinkedinShareButton,
      Icon: LinkedinIcon,
      props: { url: shareUrl },
    },
    {
      name: "Email",
      Button: EmailShareButton,
      Icon: EmailIcon,
      props: { url: shareUrl, subject: title },
    },
  ];

  return (
    <div className="w-full p-2">
      {/* header */}
      <h3 className="mb-6 text-lg font-semibold text-white">Share</h3>

      {/* social icons */}
      <div className="mb-6 grid grid-cols-6 gap-2">
        {networks.map(({ name, Button, Icon, props }) => (
          <div key={name} className="flex flex-col items-center gap-2">
            <Button
              {...(props as any)}
              className="transition-transform duration-150 hover:scale-110 active:scale-95"
            >
              <Icon size={48} round />
            </Button>
            <span className="text-[11px] text-zinc-400">{name}</span>
          </div>
        ))}
      </div>

      {/* copy link */}
      <div className="flex items-center gap-2 rounded-xl border border-white/10 bg-black/40 p-1.5 pl-4">
        <svg
          className="shrink-0 text-zinc-500"
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
        >
          <path d="M10 13a5 5 0 007.54.54l3-3a5 5 0 00-7.07-7.07l-1.72 1.71" />
          <path d="M14 11a5 5 0 00-7.54-.54l-3 3a5 5 0 007.07 7.07l1.71-1.71" />
        </svg>
        <span className="min-w-0 flex-1 truncate text-sm text-zinc-300">
          {shareUrl}
        </span>
        <button
          type="button"
          onClick={handleCopy}
          className={`shrink-0 rounded-lg px-4 py-2 text-sm font-medium transition-all duration-200 ${
            copied
              ? "bg-green-600 text-white"
              : "bg-red-600 text-white hover:bg-red-500"
          }`}
        >
          {copied ? "Copied!" : "Copy"}
        </button>
      </div>
    </div>
  );
}

export default SocialMediaPopUp;